/**
 * Created by daniel on 23/04/17.
 */
import * as _ from "lodash";
let cleanse = (item) => item === undefined ? undefined : JSON.parse(JSON.stringify(item));

/**
 * Returns the current set of item definition categories
 * @param state
 * @returns {Object.<ContentCategoryName>}
 */
export const getContentItemDefCategories = (state) => cleanse(state.editor.config.contentDefinitionCategories);

/**
 * Returns all of the current set of content definitions
 * @param state
 * @returns {Array.<ContentDefinition>}
 */
export const getContentDefinitions = (state) => cleanse(state.editor.config.contentDefinitions);

/**
 * Returns a single content item definition
 * @param state
 * @param configId
 * @returns {ContentDefinition}
 */
export const getContentDefinition = (state, configId) => cleanse(_.head(_.filter(state.editor.config.contentDefinitions, {configId})));

export const getColours = (state) => cleanse(state.editor.config.colors);


// WEBPACK FOOTER //
// ./src/App/Editor/state/config/selectors.js